<div class="home-container">
  <!-- Hero Section -->
  <section class="hero-section">
    <div class="hero-overlay">
      <div class="hero-content noselect">
        <div class="logo-section">
          <img src="../../assets/kingdom-brothers-auto-transparent.png" 
               alt="Kingdom Brothers Auto LLC" 
               class="business-logo">
        </div>
        <p class="hero-subtitle">Professional Auto Repair & Roadside Service</p>
        <p class="hero-description">
          Your trusted local mechanics providing quality automotive services with integrity and expertise.
        </p>
        <div class="cta-buttons">
          <a class="cta-button primary" [href]="'tel:' + phone">
            <i class="fas fa-phone"></i>
            {{ displayPhone }}
          </a>
          <div class="cta-button primary" (click)="openContactModal()">
            <i class="fas fa-envelope"></i>
            Contact Us
          </div>
          <button
            *ngIf="permissions?.includes('VIEW_GARAGE') || permissions?.includes('VIEW_ALL_GARAGES')"
            class="cta-button primary btn-garage"
            [routerLink]="'my-garage'">
            <img class="icon-garage" src="../../assets/car-in-garage.png"/>
            My Garage
          </button>
        </div>
      </div>
    </div>
  </section>

  <!-- Services Section -->
  <section class="services-section">
    <div class="content-container">
      <h2 class="section-title noselect">Our Services</h2>
      <div class="services-grid">
        <div
          class="service-card noselect"
          *ngFor="let service of services"
          [class.open]="isServiceOpen(service.name)"
          (click)="toggleServiceCard(service.name)"
        >
          <div class="service-icon">
            <img
              src="../../assets/car-transparent.png"
              alt="Kingdom Brothers Auto Logo"
              class="w-100"
            />
          </div>

          <h3 class="service-title">{{ service.name }}</h3>

          <!-- Description ▸ visible only when card is open -->
          <p *ngIf="isServiceOpen(service.name)" class="service-desc">
            {{ service.description }}
          </p>

          <!-- CTA button -->
          <a
            *ngIf="isServiceOpen(service.name)"
            class="cta-btn mt-3"
            [href]="'tel:' + phone"
            (click)="$event.stopPropagation()"
          >
            <i class="fas fa-phone"></i> <span style="white-space: nowrap">{{ displayPhone }}</span>
          </a>
        </div>
      </div>
    </div>
  </section>

  <!-- Location Section -->
  <section class="location-section">
    <div class="content-container">
      <h2 class="section-title">Visit Our Shop</h2>
      <div class="location-content">
        <div class="location-info">
          <div class="address-card">
            <div class="address-icon">
              <i class="icon-location"></i>
            </div>
            <div class="address-details">
              <h3>Our Location</h3>
              <p class="address-text">{{ address }}</p>
              <button class="directions-button" (click)="getDirections()">
                Get Directions
              </button>
            </div>
          </div>
          
          <!-- Image Carousel -->
          <div class="shop-gallery">
            <ngb-carousel #carousel [interval]="4000" [showNavigationArrows]="true" [showNavigationIndicators]="true">
              <ng-template ngbSlide *ngFor="let image of shopImages; let i = index">
                <div class="carousel-image-container">
                  <img [src]="image.src" [alt]="image.alt" class="carousel-image">
                  <div *ngIf="image?.caption" class="carousel-caption">
                    <p>{{ image.caption }}</p>
                  </div>
                </div>
              </ng-template>
            </ngb-carousel>
          </div>
        </div>

        <!-- Google Maps -->
        <div class="map-container">
          <iframe 
            [src]="mapEmbedUrl" 
            width="100%" 
            height="400" 
            style="border:0;" 
            allowfullscreen="" 
            loading="lazy" 
            referrerpolicy="no-referrer-when-downgrade"
            title="Kingdom Brothers Auto Location">
          </iframe>
        </div>
      </div>
    </div>
  </section>

    <!-- Google Reviews Section -->
  <div class="reviews-section">
    <div class="content-container">
      <h2 class="reviews-title">What Our Customers Say</h2>

      <div class="row justify-content-center mt-4 mx-0" *ngIf="!loadingReviews">
        <div class="col-12 px-0">
          <div class="reviews-container">
            <div class="review-card" *ngFor="let review of googleReviews; trackBy: trackByAuthor">
              <div class="review-header">
                <img [src]="review.profile_photo_url" 
                    [alt]="review.author_name + ' profile photo'" 
                    class="reviewer-photo">
                <div class="reviewer-info">
                  <h5 class="reviewer-name">{{ review.author_name }}</h5>
                  <div class="review-meta">
                    <div class="review-stars">
                      <span *ngFor="let star of getStars(review.rating)" 
                            [class.filled]="star === '★'" 
                            [class.empty]="star === '☆'">
                        {{ star }}
                      </span>
                    </div>
                    <span class="review-time">{{ review.relative_time_description }}</span>
                  </div>
                </div>
              </div>
              <div class="review-text-container">
                <p class="review-text" 
                  [class.expanded]="isReviewExpanded(review.author_name + review.time)">
                  <span *ngIf="!isReviewExpanded(review.author_name + review.time) && shouldShowReadMore(review.text)">
                    {{ getTruncatedText(review.text) }}
                  </span>
                  <span *ngIf="isReviewExpanded(review.author_name + review.time) || !shouldShowReadMore(review.text)">
                    {{ review.text }}
                  </span>
                </p>
                <button 
                  *ngIf="shouldShowReadMore(review.text)"
                  class="read-more-btn"
                  [class.expanded]="isReviewExpanded(review.author_name + review.time)"
                  (click)="toggleReviewExpansion(review.author_name + review.time)">
                  {{ isReviewExpanded(review.author_name + review.time) ? 'Read Less' : 'Read More' }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="text-center mt-4" *ngIf="loadingReviews">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Loading reviews...</span>
        </div>
      </div>

      <div class="text-center mt-4" *ngIf="!loadingReviews && googleReviews.length === 0">
        <p class="no-reviews">No reviews available at this time.</p>
      </div>

      <div class="text-center mt-4">
        <a href="https://maps.app.goo.gl/5gzeDkzPN6BSTXVZ6" 
          target="_blank" 
          class="btn btn-outline-primary">
          Review us on Google!
        </a>
      </div>
    </div>
  </div>

  <!-- Contact Section -->
  <section class="contact-section">
    <div class="content-container">
      <h2 class="section-title">Get In Touch</h2>
      <div class="contact-grid">
        <!-- Phone Card -->
        <div class="contact-card">
          <div class="contact-icon">
            <i class="fas fa-phone"></i>
          </div>
          <h3>Call Us</h3>
          <p class="contact-info">{{ displayPhone }}</p>
          <a class="contact-button" [href]="'tel:' + phone">Call Now</a>
        </div>
        <!-- Email Card -->
        <div class="contact-card">
          <div class="contact-icon">
            <i class="fas fa-envelope"></i>
          </div>
          <h3>Email Us</h3>
          <p class="contact-info">{{ email }}</p>
          <div class="contact-button" (click)="openContactModal()">Send Email</div>
        </div>
        <!-- Facebook Card -->
        <div class="contact-card">
          <div class="contact-icon">
            <i class="fab fa-facebook-f"></i>
          </div>
          <h3>Facebook</h3>
          <p class="contact-info">&#64;kingdombrothersauto</p>
          <a class="contact-button" href="https://www.facebook.com/profile.php?id=61575446685642" target="_blank">Visit Page</a>
        </div>
        <!-- Instagram Card -->
        <div class="contact-card">
          <div class="contact-icon">
            <i class="fab fa-instagram"></i>
          </div>
          <h3>Instagram</h3>
          <p class="contact-info">&#64;kingdom_brothers_auto</p>
          <a class="contact-button" href="https://www.instagram.com/kingdom_brothers_auto" target="_blank">Visit Page</a>
        </div>
      </div>
    </div>
  </section>
</div>